import { z } from 'zod';
import { localeSchema, currencyCodeSchema, countryCodeSchema } from './common';

export const updateProfileSchema = z.object({
  name: z.string().min(2).max(120).optional(),
  email: z.string().email().toLowerCase().optional(),
  countryCode: countryCodeSchema.optional(),
  taxId: z.string().min(1).max(64).optional(),
});
export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;

export const updatePasswordSchema = z
  .object({
    currentPassword: z.string().min(1),
    password: z.string().min(8).max(128),
    passwordConfirmation: z.string(),
  })
  .refine((d) => d.password === d.passwordConfirmation, {
    message: 'Parolalar uyuşmuyor',
    path: ['passwordConfirmation'],
  });
export type UpdatePasswordInput = z.infer<typeof updatePasswordSchema>;

export const updatePreferencesSchema = z.object({
  locale: localeSchema.optional(),
  timezone: z.string().optional(),
  theme: z.enum(['light', 'dark', 'system']).optional(),
  baseCurrency: currencyCodeSchema.optional(),
  countryCode: countryCodeSchema.optional(),
  dashboardSectionOrder: z.array(z.string()).optional(),
  notifications: z
    .object({
      email: z.boolean().optional(),
      browser: z.boolean().optional(),
      paymentReminders: z.boolean().optional(),
      groupActivity: z.boolean().optional(),
    })
    .optional(),
  // 💬 Sohbet onay politikası: 'confident' (yüksek güvende oto-commit) | 'always-confirm' (her zaman taslak).
  chatAutoCommit: z.enum(['confident', 'always-confirm']).optional(),
});
export type UpdatePreferencesInput = z.infer<typeof updatePreferencesSchema>;

export const consentSchema = z.object({
  cookieEssential: z.boolean(),
  cookieAnalytics: z.boolean().optional(),
  cookieMarketing: z.boolean().optional(),
  privacyPolicyVersion: z.string().min(1).max(32),
});
export type ConsentInput = z.infer<typeof consentSchema>;
